var map = {
	"./2023/autumn/poster/team_honor_jijun.png": "b58a",
	"./2024/winter/poster/team_honor_jijun.png": "9e3f",
	"./2025/spring/poster/team_honor_jijun.png": "8f89",
	"./2025/summer/poster/team_honor_jijun.png": "bab1",
	"./2025/winter/poster/team_honor_jijun.png": "7acb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7eb6";